import { useProjectStore } from '@/stores/project/index.store.ts';
import { useWorkspaceStore } from '@/stores/workspace.store.js';
import { defineStore } from 'pinia';

export const useModalStore = defineStore({
  id: 'modal',
  state: () => ({
    importUsersSpreadsheet: {
      isOpen: false,
    },
    importUsersDataViewer: {
      isOpen: false,
      hiddenTabs: [],
    },
    createNewProject: {
      isOpen: false,
    },
    createNewWorkspace: {
      isOpen: false,
    },
    contentUploader: {
      isOpen: false,
      creatorMode: false,
    },
    mediaVideoPlayer: {
      isOpen: false,
      media: null,
      props: null,
      store: null,
    },
    album: {
      isOpen: false,
      album: null,
    },
    updateMediaStatus: {
      isOpen: false,
      media: null,
    },
    addToAlbum: {
      isOpen: false,
      data: null,
    },
    downloadAsset: {
      isOpen: false,
      data: null,
    },
    updateNotificationUsersModal: {
      isOpen: false,
      data: null,
    },
    editProducts: {
      isOpen: false,
    },
    inviteProjectUsers: {
      isOpen: false,
      project: null,
      role: null,
    },
    inviteProjectCreators: {
      isOpen: false,
      project: null,
    },
    clientAccess: {
      isOpen: false,
      projectView: null,
      workspaceId: null,
      teamMembers: null,
    },
  }),
  actions: {
    showImportUsersSpreadsheetModal(boolean) {
      this.importUsersSpreadsheet.isOpen = boolean;
    },
    showImportUsersDataViewerModal(boolean, hiddenTabs) {
      this.importUsersDataViewer.isOpen = boolean;
      this.importUsersDataViewer.hiddenTabs = hiddenTabs;
    },
    showCreateNewProjectModal(boolean) {
      this.createNewProject.isOpen = boolean;
    },
    showCreateNewWorkspaceModal(boolean) {
      this.createNewWorkspace.isOpen = boolean;
    },
    showContentUploaderModal(boolean, creatorMode = false) {
      this.contentUploader.isOpen = boolean;
      this.contentUploader.creatorMode = creatorMode;
    },
    showMediaPlayerModal(boolean, media, props, store) {
      this.mediaVideoPlayer.isOpen = boolean;
      this.mediaVideoPlayer.media = media;
      this.mediaVideoPlayer.props = props;
      this.mediaVideoPlayer.store = store;
    },
    showUpdateMediaStatusModal(boolean, media) {
      this.updateMediaStatus.isOpen = boolean;
      this.updateMediaStatus.media = media;
    },
    showEditAlbumModal(boolean, album) {
      this.album.isOpen = boolean;
      this.album.album = album;
    },
    showAddToAlbumModal(boolean, data) {
      this.addToAlbum.isOpen = boolean;
      this.addToAlbum.data = data;
    },

    showDownloadAssetModal(boolean, data) {
      this.downloadAsset.isOpen = boolean;
      this.downloadAsset.data = data;
    },
    showUpdateNotificationUsersModal(boolean, data) {
      this.updateNotificationUsersModal.isOpen = boolean;
      this.updateNotificationUsersModal.data = data;
    },
    showEditProductsModal(boolean) {
      this.editProducts.isOpen = boolean;
    },
    showInviteProjectUsersModal(boolean, role) {
      this.inviteProjectUsers.isOpen = boolean;
      this.inviteProjectUsers.role = role;
    },
    async showInviteProjectCreatorModal(boolean, projectId) {
      if (boolean) {
        this.inviteProjectCreators.isOpen = boolean;
        this.inviteProjectCreators.project = projectId;
        await useProjectStore().getProjectCreatorInvites(Number(projectId));
      } else {
        this.inviteProjectCreators.isOpen = boolean;
        this.inviteProjectCreators.project = null;
      }
    },
    async showClientAccessModal(boolean, projectView, workspaceId) {
      if (boolean) {
        const teamMembers = await new Promise((resolve) => {
          console.log('teamMembers start');
          //const payload = { workspace_id: parseInt(workspaceId), role: "Workspace_Client" };
          //API.sendQuery('/graphql/workspace', GET_WORKSPACE_TEAM_MEMBERS_QUERY, payload)
          useWorkspaceStore()
            .getTeamMembers(workspaceId, 'Workspace_Client')
            .then((res) => {
              if (res.data.data.teamMembers) {
                console.log('teamMembers fetched');
                resolve(res.data.data.teamMembers.map((element) => element.user));
              } else {
                resolve([]);
              }
            })
            .catch((error) => {
              console.error('Error fetching team members:', error);
              resolve([]);
            });
        });
        this.clientAccess.teamMembers = teamMembers;
        this.clientAccess.isOpen = boolean;
        this.clientAccess.projectView = projectView;
        this.clientAccess.workspaceId = workspaceId;
        console.log('showClientAccessModal', this.clientAccess);
      }
    },
  },
});
